import React from 'react';
import { ReservationFloatingButtonV2 } from 'views/rebranded-module/common/components';
import dynamic from 'next/dynamic';

const MainWidgetDialogV2 = dynamic(() => import(
  'views/rebranded-module/common/components/UI/MainWidgetDialogV2/MainWidgetDialogV2'
).then((file) => file.MainWidgetDialogV2));

const FloatingButtonWithFloatingDialogV2 = (props) => {
  const {
    text,
    widgetDialogData,
    handleFloatingPointClick,
    handleWidgetDialogClose,
    scrollValue,
    reservationData,
  } = props;

  return (
    <>
      <ReservationFloatingButtonV2
        text={text}
        scrollValue={scrollValue}
        handleClick={handleFloatingPointClick}
      />
      {widgetDialogData.open && (
        <MainWidgetDialogV2
          scrollValue={scrollValue}
          open={widgetDialogData.open}
          handleClose={handleWidgetDialogClose}
          reservationData={reservationData}
          container={() => document.getElementById('floatingButton')}
          floatingDialog
          renderFullWidgetByForce
          {...widgetDialogData}
          {...props}
        />
      )}
    </>
  );
};

export { FloatingButtonWithFloatingDialogV2 };
